/**
 * Redux Selectors with Memoization (using RTK createSelector)
 * These prevent unnecessary component re-renders by memoizing selector results
 */

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from './store';

// Base selectors
const selectNavigationState = (state: RootState) => state.navigationdata;

// Navigation selectors
export const selectModalData = createSelector([selectNavigationState], (navigation) => navigation.modalData);

export const selectToastData = createSelector([selectNavigationState], (navigation) => navigation.toastData);

export const selectLoading = createSelector([selectNavigationState], (navigation) => navigation.loading);

export const selectIsModalOpen = createSelector([selectModalData], (modalData) => modalData.open);

export const selectModalBody = createSelector([selectModalData], (modalData) => modalData.body);
